module.exports = __webpack_public_path__ + "img/login_scan.7b617104.png";